// @flow
import * as React from 'react';
import styled, {css} from 'styled-components';

type Props = {
  widthM?: number,
  heightM?: number,
  widthD?: number,
  heightD?: number,
}

export default function Logo(props: Props): React.Element<any> {
  return (
    <DivSpace datawidthm={props.widthM} dataheightm={props.heightM} datawidthd={props.widthD} dataheightd={props.heightD} />
  );
}

const DivSpace = styled.div`
  ${(props) => ((props.datawidthm || props.datawidthd) && css`
  width: ${(props) => (props.theme.layout.mobile ? props.datawidthm ?? 0 : props.datawidthd ?? 0)}px;
  `)}

  ${(props) => ((props.dataheightm || props.dataheightd) && css`
  height: ${(props) => (props.theme.layout.mobile ? props.dataheightm ?? 0 : props.dataheightd ?? 0)}px;
  `)}
`;
